import { createContext } from "react";
import type {
  AcceptInviteResponse,
  ApiUser,
  AuthResponse,
  SaasLoginResult,
} from "@/lib/api/auth";
import type { StoredTokens } from "@/lib/auth-storage";
import type { MfaFactorMethod } from "@/features/saas-mfa/api";

export interface AuthContextValue {
  user: ApiUser | null;
  loading: boolean;
  sessionRefreshWarning: string | null;
  login: (
    email: string,
    password: string,
    captchaToken?: string,
  ) => Promise<SaasLoginResult>;
  loginAdmin: (
    email: string,
    password: string,
    captchaToken?: string,
  ) => Promise<SaasLoginResult>;
  completeMfaLogin: (input: {
    challengeToken: string;
    method: MfaFactorMethod;
    code: string;
  }) => Promise<AuthResponse>;
  /** Completes an MFA login with a WebAuthn assertion (passkeys release). */
  completePasskeyLogin: (input: {
    challengeToken: string;
    credential: Record<string, unknown>;
  }) => Promise<AuthResponse>;
  logout: () => Promise<void>;
  acceptInvite: (input: {
    token: string;
    email: string;
    password: string;
    firstName?: string;
    lastName?: string;
  }) => Promise<AcceptInviteResponse>;
  setTokens: (tokens: StoredTokens) => void;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined,
);
